import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { ArquivosDataGrid } from '../../organisms';
import { MRTFilters } from '../../molecules';
import MRTFiltersProvider from '../../../contexts/MRTFiltersContext';
import { PageTemplate } from '../';

const ArquivosTemplate = memo(props => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;
  const xContent = (
    <>
      <ArquivosDataGrid {...restDataGridProps} initialState={initialState} state={state} />
      <MRTFilters />
    </>
  );

  return (
    <PageTemplate
      title={props.title}
      subtitle={props.subtitle}
      description={props.description}
      scrollable={true}
      headerRenderActions={props.headerRenderActions}>
      <MRTFiltersProvider value={props.dataGridProps}>
        {typeof props.contentWrapper === 'function' ? props.contentWrapper(xContent) : xContent}
      </MRTFiltersProvider>
    </PageTemplate>
  );
});

ArquivosTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  contentWrapper: PropTypes.func,
  dataGridProps: PropTypes.object
};

export default ArquivosTemplate;
